import initDepotSelectors from './modules/depot-selector';
import initProductSingleAccordions from './modules/product-single-accordion';

function onDomReady(callback) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback);
    return;
  }

  callback();
}

onDomReady(() => {
  initDepotSelectors();
  initProductSingleAccordions();
});
